export const START_LOAD = 'number/START_LOAD';
export const FINISH_LOAD = 'number/FINISH_LOAD';

const initialState = {
    loading:false,
    number:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, number:action.payload};
        default: return state;
    }
}